import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { ReactComponent as Logo } from '../assets/logo-light.svg';

const COLS = [
  {
    heading: 'Learn',
    links: [
      { name: 'Courses', href: '/courses' },
      { name: 'Research workshops', href: '/research' },
      { name: 'Accreditation prep', href: '/accreditation' },
      { name: 'Program development', href: '/programs' },
      { name: 'Tools', href: '/tools' },
    ],
  },
  {
    heading: 'Academy',
    links: [
      { name: 'About', href: '/about' },
      { name: 'Facilitators', href: '/facilitators' },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="bg-ink text-bone/85 mt-24 print:hidden">
      <div className="container-page pt-12 lg:pt-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Link to="/" aria-label="Learning Outcomes Academy — home" className="inline-block bg-bone rounded-xl p-3">
              <Logo
                aria-hidden="true"
                className="h-12 w-auto text-ink"
              />
            </Link>
            <p className="mt-6 max-w-md text-bone/70 leading-relaxed">
              Learning Outcomes Academy bridges education, research, technology, and
              institutional development — helping learners and organizations move from
              knowledge to measurable impact.
            </p>

            <Link
              to="/contact"
              className="group mt-8 inline-flex items-center gap-3 text-bone border-b border-bone/40 hover:border-bone pb-1 transition-colors"
            >
              Work with us
              <FaArrowRight className="text-xs transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-8">
            {COLS.map((col) => (
              <div key={col.heading}>
                <div className="text-[11px] tracking-[0.18em] uppercase text-bone/50 mb-4">
                  {col.heading}
                </div>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.name}>
                      <Link
                        to={l.href}
                        className="text-bone/85 hover:text-bone transition-colors"
                      >
                        {l.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 py-4 border-t border-bone/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-sm text-bone/60">
          <span>&copy; {new Date().getFullYear()} Learning Outcomes Academy. All rights reserved.</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-bone transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-bone transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
